import React from "react";

const RefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.137"
      height="16.109"
      viewBox="0 0 15.137 16.109"
    >
      <g id="refresh" transform="translate(-3.547 -3)">
        <path
          id="Path_225510"
          data-name="Path 225510"
          d="M17.919,11.625a.886.886,0,0,0-1.016.755,5.731,5.731,0,0,1-1.638,3.239A5.818,5.818,0,1,1,7.037,7.391,5.741,5.741,0,0,1,10.173,5.78a5.538,5.538,0,0,1,1.654-.05,5.742,5.742,0,0,1,2.207.742l-1.165.2a.9.9,0,0,0,.15,1.778.9.9,0,0,0,.152-.013L16.3,7.9a.895.895,0,0,0,.731-1.034l-.535-3.124a.895.895,0,1,0-1.764.3l.141.822a7.54,7.54,0,0,0-2.838-.917,7.253,7.253,0,0,0-2.174.067A7.5,7.5,0,0,0,5.772,6.125,7.608,7.608,0,0,0,16.531,16.885a7.511,7.511,0,0,0,2.143-4.244.9.9,0,0,0-.755-1.016Z"
          transform="translate(0 0)"
          fill="#4c5a6b"
        />
      </g>
    </svg>
  );
};

export default RefreshIcon;
